import React, { useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import "./popupboxx.css";

function Popupboxx({ isOpen, onClose }) {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [captchaVerified, setCaptchaVerified] = useState(false);


  const handleCaptchaChange = (value) => {
    if (value) {
      setCaptchaVerified(true); // Set to true when CAPTCHA is verified
    } else {
      setCaptchaVerified(false); // Set to false if not verified
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const validateForm = () => {
    let newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/.test(formData.email)) {
      newErrors.email = "Invalid email format";
    }
    if (!formData.phone.trim()) {
      newErrors.phone = "Phone number is required";
    } else if (!/^\d{10}$/.test(formData.phone)) {
      newErrors.phone = "Enter a valid 10-digit phone number";
    }
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formErrors = validateForm();

    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return;
    }
    if (!captchaVerified) {
      setErrors("Please verify that you are not a robot.");
      return;
    }
    setLoading(true); // Start loading

    try {
      const response = await fetch("https://demo.nspp.in/php/send_email.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          fullName: formData.name,
          email: formData.email,
          phone: formData.phone,


        }),
      });

      const result = await response.json();


      if (response.ok) {

        setFormData({ name: "", email: "", phone: "", });
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      // alert("Something went wrong. Please try again.");
    } finally {
      setLoading(false); // Stop loading
      alert("send successfully")
    }
  };
  if (!isOpen) return null; // hide popup if not open

  return (
    <>
      <div className="popup-overlay" onClick={onClose}></div>

      <div className="popup-form">
        <span className="close-btn" onClick={onClose}>
          &times;
        </span>

        <h2>Smart Designs, Smart Prices</h2>
        <p>Get Request</p>

        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleChange}
            required
          />

          <input
            type="email"
            name="email"
            placeholder="Your Email"
            value={formData.email}
            onChange={handleChange}
            required
          />

          <input
            type="tel"
            name="phone"
            placeholder="Your Phone"
            value={formData.phone}
            onChange={handleChange}
            required
          />
          {errors.phone && <p className="error">{errors.phone}</p>}

          <ReCAPTCHA
            sitekey="6LeiptIqAAAAAKT6diIfDS8Wu3vU-4SEIYxA0yB3"
            // sitekey="6LdyK74qAAAAAHior1ETtBZRJf6-78AZFgkPYKf3"

            onChange={handleCaptchaChange}
          />
          <br />

          <button type="submit" className="header-submit" disabled={loading}>
            {loading ? "Sending..." : "Submit"}
          </button>
        </form>

        {responseMessage && (
          <p className="response-message">{responseMessage}</p>
        )}
      </div>
    </>
  );
}

export default Popupboxx;
